import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 32,
  height: 39,
}

const bathroomCabinet = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 31.667 38.603'
  >
    <g fill={color}>
      <path
        d='M51.309,214.476a.754.754,0,0,0,.754-.754V200.754a.754.754,0,0,0-.754-.754H40.754a.754.754,0,0,0-.754.754v12.968a.754.754,0,0,0,.754.754Zm-9.8-12.968h9.048v11.46H41.508Zm0,0'
        transform='translate(-36.984 -184.921)'
      />
      <path
        d='M231.309,214.476a.754.754,0,0,0,.754-.754V200.754a.754.754,0,0,0-.754-.754H220.754a.754.754,0,0,0-.754.754v12.968a.754.754,0,0,0,.754.754Zm-9.8-12.968h9.048v11.46h-9.048Zm0,0'
        transform='translate(-203.413 -184.921)'
      />
      <path
        d='M260.754,266a.754.754,0,0,0-.754.754v3.016a.754.754,0,1,0,1.508,0v-3.016A.754.754,0,0,0,260.754,266Zm0,0'
        transform='translate(-240.397 -245.945)'
      />
      <path
        d='M140.754,266a.754.754,0,0,0-.754.754v3.016a.754.754,0,0,0,1.508,0v-3.016A.754.754,0,0,0,140.754,266Zm0,0'
        transform='translate(-129.445 -245.945)'
      />
      <path
        d='M1.508,286.754A.754.754,0,1,1,.754,286,.754.754,0,0,1,1.508,286.754Zm0,0'
        transform='translate(0 -264.437)'
      />
      <path d='M0,37.849a.754.754,0,0,0,.754.754H3.77a.754.754,0,0,0,.674-.417l1.3-2.6H25.923l1.3,2.6a.754.754,0,0,0,.674.417h3.016a.754.754,0,0,0,.754-.754V14.325A2.264,2.264,0,0,0,29.4,12.063H28.145a8.272,8.272,0,0,0,3.521-6.786.754.754,0,0,0-.754-.754H24.127V3.016h.754a.754.754,0,1,0,0-1.508H21.865a.754.754,0,0,0,0,1.508h.754V4.524H16.587V2.262a.754.754,0,1,1,1.508,0,.754.754,0,1,0,1.508,0,2.262,2.262,0,1,0-4.524,0V4.524H12.063V3.016h.754a.754.754,0,0,0,0-1.508H9.8a.754.754,0,1,0,0,1.508h.754V4.524H.754A.754.754,0,0,0,0,5.278a8.29,8.29,0,0,0,3.531,6.786H2.262A2.264,2.264,0,0,0,0,14.325V19.3a.754.754,0,0,0,1.508,0V14.325a.755.755,0,0,1,.754-.754H29.4a.755.755,0,0,1,.754.754V31.063H1.508v-5.73a.754.754,0,1,0-1.508,0ZM8.294,12.063A6.8,6.8,0,0,1,1.549,6.031H30.117a6.785,6.785,0,0,1-6.744,6.033ZM1.508,32.571H30.159V37.1h-1.8l-1.3-2.6a.754.754,0,0,0-.674-.417H5.278A.754.754,0,0,0,4.6,34.5L3.3,37.1h-1.8Zm0,0' />
    </g>
  </svg>
)

export default bathroomCabinet
